var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuThreeDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "24px",
    viewBox: "0 0 6 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "14DCF30E-EE6F-4E46-A626-5E6D0129E9B3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QA-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Stage-Filled-Out",
    transform: "translate(-963.000000, -462.000000)",
    fill: "#8D8D8D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M966.011279,480.427381 C967.330748,480.427381 968.40039,481.497022 968.40039,482.816492 C968.40039,484.135962 967.330748,485.205604 966.011279,485.205604 C964.691809,485.205604 963.622167,484.135962 963.622167,482.816492 C963.622167,481.497022 964.691809,480.427381 966.011279,480.427381 Z M966.011279,471.660242 C967.330748,471.660242 968.40039,472.729884 968.40039,474.049354 C968.40039,475.368823 967.330748,476.438465 966.011279,476.438465 C964.691809,476.438465 963.622167,475.368823 963.622167,474.049354 C963.622167,472.729884 964.691809,471.660242 966.011279,471.660242 Z M966.011279,462.893104 C967.330748,462.893104 968.40039,463.962745 968.40039,465.282215 C968.40039,466.601685 967.330748,467.671326 966.011279,467.671326 C964.691809,467.671326 963.622167,466.601685 963.622167,465.282215 C963.622167,463.962745 964.691809,462.893104 966.011279,462.893104 Z",
    id: "Document-Menu"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuThreeDots);
export default __webpack_public_path__ + "static/media/menu-three-dots.613d878c97963d53bb185d16c2893bd6.svg";
export { ForwardRef as ReactComponent };